export { EventFigure, type EventFigureProps } from './EventFigure';
